"use client";

import dynamic from "next/dynamic";
import { renderNothingIfChunkFails } from "@/lib/optional-chunk";

export const TourFeedbackModal = dynamic(
  () =>
    renderNothingIfChunkFails(
      import("@/components/onboarding/tour-feedback-modal").then((mod) => mod.TourFeedbackModal),
    ),
  { ssr: false },
);
